import React from "react";
import { useTranslation } from "react-i18next";
import { getCountries, getCountryDisplayName } from "src/services/countryService";

/** Shows a stored (English) country name in the user's language, falling back to the stored name. */
export const useCountryName = (storedName: string | null | undefined) => {
    const { i18n } = useTranslation();
    const [countries, setCountries] = React.useState<API.Country[]>([]);

    React.useEffect(() => {
        if (!storedName) {
            return;
        }
        let active = true;
        getCountries()
            .then((list) => {
                if (active) {
                    setCountries(list);
                }
            })
            .catch(() => undefined);
        return () => {
            active = false;
        };
    }, [storedName]);

    const country = countries.find((item) => item.country === storedName);
    return country ? getCountryDisplayName(country, i18n.language) : storedName;
};
